export class LookupUserResponse {
  constructor(
    data?: Array<any>,
    success?: boolean,
    errors?: Array<any>,
    requestid?: string,
    status?: number
    ){}
}

export class LookupUserRequest {}
